import React, { FC, useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";

import axios from "axios";
import { baseServiceUrl, urls } from "../../../environment";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

type ScruitnySectionProps = {};
const ScruitnySection: FC<ScruitnySectionProps> = () => {
  const [side, setside] = useState<boolean>(false);
  const navigate = useNavigate();

  //   userDetails?.resultOfExamPapers?.exam_list[0];
  const handleSide = () => {
    setside((prev) => !prev);
  };

  return (
    <div>
      <div className=" flex">
        <div className="fixed top-0 left-0 lg:w-[280px]  min-h-[100vh]">
          <Sidebar side={side} handleside={handleSide} />
        </div>
        <div className=" w-[100vw] min-h-[100vh] ml-[320px]  md:mt-5 ">
          <p className="text-[35px] ml-5 font-semibold">Scrutiny Section </p>
          <div className="flex justify-end items-center w-[98%]">
            <Button
              onClick={() =>
                navigate(`/dashboard/examinee-portal/create-scrutiny`)
              }
              variant="contained"
            >
              Raise Objection
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScruitnySection;
